import { render } from "./InstallPwaBanner.vue?vue&type=template&id=2627d9e6&scoped=true"
import script from "./InstallPwaBanner.vue?vue&type=script&lang=js"
export * from "./InstallPwaBanner.vue?vue&type=script&lang=js"

import "./InstallPwaBanner.vue?vue&type=style&index=0&id=2627d9e6&lang=scss"
import "./InstallPwaBanner.vue?vue&type=style&index=1&id=2627d9e6&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2627d9e6"]])

export default __exports__